import Vue from "vue";

/**
 * Class CPA Service
 */
export default class ClassifyService extends Vue {
    private customActions = {
        classifyMessage: { method: "POST", url: "https://dev-api.weclever.co/hsm-classify" }
    };

    private resource: any = this.$resource(
        "https://dev-api.weclever.co/hsm-classifyhsm-classify",{},this.customActions
    );

    // POST
    public async classifyMessage(message: string) {
        const params = {
            columns: ["col 1"],
            index: [1],
            data: [[message]]
        }

        return await this.resource.classifyMessage({}, params).then((response: any) => {
            return response.data;
        }, (error: any) => {
            return Promise.reject(error);
        });
    }
}
